module.exports = __webpack_public_path__ + "static/media/tinyBuilding.3b335eac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tinyBuilding.svg
// module id = 501
// module chunks = 0